var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M6.062 9.75H2.937a.938.938 0 00-.937.938v9.374c0 .518.42.938.937.938h3.125c.518 0 .938-.42.938-.938v-9.375a.938.938 0 00-.938-.937zM4.5 19.438a.938.938 0 110-1.876.938.938 0 010 1.876zM17 4.181c0 1.657-1.014 2.586-1.3 3.693h3.974c1.304 0 2.32 1.084 2.326 2.27.003.7-.295 1.454-.76 1.921l-.004.005c.385.911.322 2.188-.363 3.104.339 1.011-.003 2.254-.64 2.92.168.687.087 1.272-.24 1.743C19.195 20.984 17.219 21 15.548 21h-.11c-1.887 0-3.43-.687-4.671-1.24-.623-.277-1.438-.62-2.057-.631a.47.47 0 01-.46-.469v-8.35c0-.125.05-.245.139-.333 1.547-1.53 2.213-3.148 3.481-4.419.578-.579.789-1.454.992-2.3.174-.723.537-2.258 1.325-2.258C15.125 1 17 1.313 17 4.182z"
  }))));
}

export default SvgThumbsUp;